/* loaded by smart-asset */
export default require("./38-check-box-m~DyPbawTw.svg")